import { render } from "./JobspecialServiceNumber.vue?vue&type=template&id=35b5fe4a&scoped=true"
import script from "./JobspecialServiceNumber.vue?vue&type=script&lang=js"
export * from "./JobspecialServiceNumber.vue?vue&type=script&lang=js"

import "./JobspecialServiceNumber.vue?vue&type=style&index=0&id=35b5fe4a&scoped=true&lang=css"
import "./JobspecialServiceNumber.vue?vue&type=style&index=1&id=35b5fe4a&lang=css"
script.render = render
script.__scopeId = "data-v-35b5fe4a"

export default script